module.exports = __webpack_public_path__ + "files/Appel à communication 7-10.7fbb3c6c4f7b7304d45c2a5dda23984d.pdf";